var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("page-header", {
        attrs: {
          light: "",
          "dark-crumb": "",
          title:
            "Согласие на получение рекламных, информационных и иных сообщений",
        },
      }),
      _c("content-wrapper-block", [
        _c("div", { staticClass: "promotion" }, [
          _c("div", { staticClass: "promotion-text" }, [
            _c("p", [
              _vm._v(
                " Настоящим, выражая согласие путем проставления отметки («галочки») в соответствующем чек-боксе при заполнении своих контактных данных через форму на Сайте, действуя свободно, своей волей и в своем интересе, я подтверждаю, что даю Акционерному обществу «ГК ОСНОВА», зарегистрированного по адресу: 142702, Московская обл., город Видное, поселок городского типа Бутово, территория жилой комплекс Бутово-Парк, д. 18, пом. 59 (далее - Оператор) согласие на направление мне рекламных, информационных и иных сообщений о товарах (продуктах), работах, услугах, публичных мероприятиях и маркетинговых программах Оператора (далее – Реклама) посредством: "
              ),
            ]),
            _c("p", [
              _vm._v(" - СМС;"),
              _c("br"),
              _vm._v(" - сообщений в социальных сетях и мессенджеров;"),
              _c("br"),
              _vm._v(" - телефонных звонков;"),
              _c("br"),
              _vm._v(" - электронной почты;"),
              _c("br"),
              _vm._v(
                " - иным образом по предоставленным мною в адрес Оператора контактным данным. "
              ),
            ]),
            _c("p", [
              _vm._v(" Перечень обрабатываемых персональных данных:"),
              _c("br"),
              _vm._v(" - фамилия, имя, отчество;"),
              _c("br"),
              _vm._v(
                " - контактные данные (номер телефона, адрес электронной почты, псевдоним (идентификатор) в социальных сетях и сервисах коммуникаций);"
              ),
              _c("br"),
              _vm._v(" - иные персональные данные, сообщенные мною. "),
            ]),
            _c("p", [
              _vm._v(
                " Действия с персональными данными: автоматизированная и неавтоматизированная (смешанная) обработка посредством осуществления следующих действий: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, передача (предоставление, доступ), блокирование, удаление, уничтожение. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Я подтверждаю, что являюсь дееспособным лицом и могу самостоятельно давать согласие на получение рекламы и обработку своих персональных данных с этой целью. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Я также подтверждаю, что предоставленные мною номер телефона и/или адрес электронной почты принадлежат мне, а направляемая на них Реклама предназначена только для меня и не будет получаться третьими лицами, не давшими согласия на получение Рекламы. "
              ),
            ]),
            _c("p", [
              _vm._v(" Я уведомлён(а), что:"),
              _c("br"),
              _vm._v(
                " - согласие может быть отозвано мной в любое время путем направления письменного запроса в адрес Оператора или на электронную почту: "
              ),
              _c("a", { attrs: { href: "mailto:info@gk-osnova.ru" } }, [
                _vm._v("info@gk-osnova.ru"),
              ]),
              _vm._v(";"),
              _c("br"),
              _vm._v(
                " - мои персональные данные не будут передаваться третьим лицам без законных оснований;"
              ),
              _c("br"),
              _vm._v(
                " - обработка осуществляется в соответствии с требованиями законодательства Российской Федерации. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Настоящее согласие имеет юридическую силу, считается заполненным и является подписанным с момента заполнения формы путем принятия условий и проставления графического элемента согласия («галочки» в соответствующем чек-боксе), являющегося заменой собственноручной подписи. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Настоящее согласие предоставляется на срок до достижения указанных целей обработки или до момента его отзыва. "
              ),
            ]),
            _c("p", [
              _vm._v(
                " Политика обработки персональных данных расположена по адресу: "
              ),
              _c(
                "a",
                {
                  staticClass: "breakable-link",
                  attrs: {
                    href: "/Политика_обработки_персональных_данных.pdf",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "https://zk-mainstreet.ru/Политика_обработки_персональных_данных.pdf"
                  ),
                ]
              ),
              _vm._v(". "),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }